module.exports = __webpack_public_path__ + "ae199f0db90f0edbedbc31b946e6c29f.fbx";